import { AppSetting, QuickBooksTaxCode } from "../models";

export const parseQuickBooksTaxCodeSetting = (
  setting?: AppSetting
): QuickBooksTaxCode | undefined => {
  const value = setting?.defaultValue;
  if (!value || typeof value !== "string" || !value.trim().startsWith("{")) {
    return undefined;
  }

  try {
    const parsed = JSON.parse(value) as Partial<QuickBooksTaxCode>;
    if (!parsed.id || !parsed.name) {
      return undefined;
    }

    return {
      id: parsed.id,
      name: parsed.name,
      rate: Number(parsed.rate ?? 0),
    };
  } catch {
    return undefined;
  }
};

export const formatQuickBooksTaxCodeLabel = (
  taxCode?: Pick<QuickBooksTaxCode, "name" | "rate">
) => {
  if (!taxCode?.name) {
    return "";
  }

  return `${taxCode.name} - ${Number(taxCode.rate ?? 0)}%`;
};
